import React, { useEffect, useState } from "react";
import { Customer } from "@/api/customers";
import { CustomerUser, TmsCustomerUser } from "@/api/users";
import RigthPanel, { RigthPanelType } from "@/ui-controls/RigthPanel";
import MigrateTmsCustomerUsersForm from "@/components/customers/customer_users/MigrateTmsCustomerUsersForm";
interface Props {
  customer: Customer | undefined;
  //customerUsers: CustomerUser[];
  tmsCustomerUsers: TmsCustomerUser[];
  isPanelOpenned: boolean;
  onPanelClosed?: () => any;
  onSave?: (
    tmsCustomerUsers: TmsCustomerUser[],
    useTmsPassword: boolean
  ) => Promise<any>;
}

const MigrateTmsCustomerUsersPanel = (props: Props) => {
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  return (
    <>
      <RigthPanel
        header={`Import users from '${props.customer?.Name}' TMS`}
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={MigrateTmsCustomerUsersForm}
        type={RigthPanelType.large}
        childProps={{
          customer: props.customer,
          //customerUsers: props.customerUsers,
          tmsCustomerUsers: props.tmsCustomerUsers,
          onClose: () => onClosePanel(),
          onSave: async (
            tmsCustomerUsers: TmsCustomerUser[],
            useTmsPassword: boolean
          ) => {
            if (props.onSave) {
              return await props.onSave(tmsCustomerUsers, useTmsPassword);
            }
            // Note: onClosePanel() is now handled by the form after success
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default MigrateTmsCustomerUsersPanel;
